<template>
  <v-container fluid class="d-flex justify-center pa-0 flex-wrap summary_wrap container__wrap">
    <div class="mt-10 user_info_wrap d-flex align-center">
      <img src="@/assets/img/icon/logo-army-60.png" alt="육군 로고" />
      <div class="ml-5">
        <p>{{ `${oralStatus.solInfo.name} 용사 (${oralStatus.solInfo.corName}, ${oralStatus.solInfo.number})` }}</p>
        <p>{{ oralStatus.solInfo.userCreated ? `${$convertDateFormat('YYMMDDKR', oralStatus.solInfo.userCreated)} 가입` : '미가입' }}</p>
        <p>{{ oralStatus.solInfo.lastLoginDate ? `가입완료 마지막접속일시: ${oralStatus.solInfo.lastLoginDate.substr(2, 8)}` : '미가입' }}</p>
      </div>
    </div>
    <div class="mt-10 d-flex">
      <v-card width="740" class="mr-5">
        <v-card-text class="card_title d-flex align-center">
          <i class="icon status_list"></i>
          <span>최근 구강상태</span>
        </v-card-text>
        <div class="px-15 card_status d-flex align-center">
          <i class="icon mr-3" :class="oralStatus.latestState ? `icon_${healthStatus[oralStatus.latestState].icon}` : ''"></i>
          <div>
            <p>최근 구강상태는 {{ oralStatus.latestState ? healthStatus[oralStatus.latestState].text : '-' }}입니다</p>
            <p>
              최근양치일
              <span>{{ oralStatus.latestDate ? calculateDate(oralStatus.latestDate) : '-' }}일 전</span>
            </p>
          </div>
        </div>
        <div class="user_chart_wrap d-flex">
          <status-doughnut-chart
            v-if="doughnutChartData.datasets[0].data.length !== 0"
            :chart-data="doughnutChartData"
            description="총 누적 양치횟수"
            :number="oralStatus.stateCount.countAll"
            unit="회"
            graph-tooltip
            :center-tooltip="`일일 평균 양치횟수: ${oralStatus.dailyAverage}회`"></status-doughnut-chart>
          <status-bar-chart v-if="Object.keys(oralStatus.comparison).length !== 0" :comparison="oralStatus.comparison" :name="oralStatus.solInfo.name"></status-bar-chart>
        </div>
      </v-card>
      <v-card width="600" class="user_calendar_wrap">
        <user-calendar v-if="dailyDataStatus ? oralStatus.daily.length !== 0 : true" :data="oralStatus.daily" @clickDate="clickDate"></user-calendar>
      </v-card>
    </div>
    <v-card width="1360" class="mt-8">
      <status-line-bar-chart v-if="oralStatus.daily.length !== 0" :daily="oralStatus.daily"></status-line-bar-chart>
    </v-card>
    <v-card width="1360" class="mt-5 mb-12 table_wrap">
      <v-data-table
        :headers="oralStatusListHeaders"
        no-data-text="데이터가 존재하지 않습니다."
        :items="oralStatus.list"
        :items-per-page="oralStatus.list.length"
        fixed-header
        hide-default-footer
        class="table_wrap"
        :loading="tableLoading">
        <template #item="row">
          <tr>
            <td>{{ $convertDateFormat('YYYYMMDDAMPMKR', row.item.date) }}</td>
            <td :style="{ color: healthStatus[row.item.soldierState].color }">{{ healthStatus[row.item.soldierState].text }}</td>
            <td>{{ row.item.percent }}%</td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
    <user-report-popup v-model="showReportPopup" :data="oralReportData" :daily="oralStatus.daily" @close="showReportPopup = false" @clickDate="clickDate"></user-report-popup>
  </v-container>
</template>

<script>
import StatusDoughnutChart from '@/components/status/StatusDoughnutChart';
import StatusBarChart from '@/components/status/StatusBarChart';
import StatusLineBarChart from '@/components/status/StatusLineBarChart';
import UserCalendar from '@/components/status/UserCalendar';
import UserReportPopup from '@/components/status/UserReportPopup';
import Api from '@/apis/api';
import { mapState } from 'vuex';
export default {
  name: 'OralStatus',
  components: {
    StatusDoughnutChart,
    StatusBarChart,
    StatusLineBarChart,
    UserCalendar,
    UserReportPopup,
  },
  data: () => ({
    oralStatus: {
      solInfo: {},
      latestDate: '',
      latestState: '',
      dailyAverage: '',
      stateCount: {},
      comparison: {},
      daily: [],
      list: [],
    },
    oralReportData: {
      solInfo: {},
      state: '',
      todayCount: '',
      comparison: {},
      oralConditionList: [],
      daily: [],
    },
    showReportPopup: false,
    doughnutChartData: {
      labels: ['S', 'G', 'A', 'D'],
      datasets: [
        {
          data: [],
          backgroundColor: ['#337eff', '#27c4aa', '#fcb519', '#e64e81'],
        },
      ],
    },
    tableLoading: false,
    dailyDataStatus: true,
    allowedDates: [],
  }),
  computed: {
    ...mapState('commonValue', ['healthStatus', 'oralStatusListHeaders']),
  },
  mounted() {
    this.getUserOralStatus(parseInt(this.$route.params.id));
  },
  methods: {
    getUserOralStatus(id) {
      this.$root.spinner.set(true);
      this.tableLoading = true;
      Api.getOralCondition({ solId: id }).then(res => {
        if (res && res.data.rt === 200) {
          for (const key in this.oralStatus) {
            this.oralStatus[key] = res.data[key];
          }
          if (res.data.daily.length === 0) this.dailyDataStatus = false;
          this.doughnutChartData.datasets[0].data.push(
            this.oralStatus.stateCount['countS'],
            this.oralStatus.stateCount['countG'],
            this.oralStatus.stateCount['countA'],
            this.oralStatus.stateCount['countD'],
          );
          this.tableLoading = false;
          this.$root.spinner.set(false);
        } else {
          this.$root.alert.show({
            content: `알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요. 오류 코드 : ${res.data.rt}`,
          });
        }
      });
    },
    getUserOralReport(form) {
      Api.getOralConditionReport(form).then(res => {
        if (res && res.data.rt === 200) {
          for (const key in this.oralReportData) {
            this.oralReportData[key] = res.data[key];
          }
          Object.assign(this.oralReportData, form);
          if (this.oralReportData.oralConditionList.length !== 3) {
            let limit = 3 - this.oralReportData.oralConditionList.length;
            for (let i = 0; i < limit; i++) {
              this.oralReportData.oralConditionList.push('');
            }
          }
        } else {
          this.$root.alert.show({
            content: `알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요. 오류 코드 : ${res.data.rt}`,
          });
        }
      });
    },
    // 몇일 전 계산
    calculateDate(val) {
      const todayDate = new Date();
      const tempDate = new Date(parseInt(val.substr(0, 4)), parseInt(val.substr(5, 2)) - 1, parseInt(val.substr(8, 2)));
      let difference = Math.abs(todayDate - tempDate);
      return parseInt(difference / (1000 * 3600 * 24));
    },
    clickDate(date) {
      let form = {
        solId: this.oralStatus.solInfo.id,
        day: date,
      };
      this.getUserOralReport(form);
      this.showReportPopup = true;
    },
  },
};
</script>

<style scoped></style>
